<!--T1005776厦门国际银行-存款达标领取活动-领取优惠券-（微信打开， or 如果有openId,直接领取） -->
<template>
  <div class="xiame-bank-deposit-standard-wx-collecting">
    <div class="header">
      <div v-if="prize.couponResults === 1">
        <img
          class="icon"
          :src="require(`@/assets/imgs/xiameBankDepositStandard/success.png`)"
          alt=""
        />
        <div class="title">恭喜您已领取成功!</div>
      </div>
      <div v-if="prize.couponResults === 0">
        <img
          class="icon"
          :src="require(`@/assets/imgs/xiameBankDepositStandard/error.png`)"
          alt=""
        />
        <div class="title">领取失败!</div>
      </div>
    </div>
    <div class="content">
      <!-- 资产达标情况和奖励展示 -->
      <img
        v-if="showStandardImg"
        class="asset-img"
        :src="
          require(`@/assets/imgs/xiameBankDepositStandard/grade${
            prize.isNew ? 'n' : ''
          }${prize.standardGear}.png`)
        "
        alt=""
      />
      <p v-if="showStandardImgError">{{ showStandardImgError }}</p>
      <div v-if="prize.couponResults === 1" class="success">
        <p class="tip">
          请前往<span class="red">【微信卡包】</span>查看你的微信立减金
        </p>
        <div class="rule">
          <h4>使用规则:</h4>
          <p v-html="details"></p>
        </div>
      </div>
      <div v-if="prize.couponResults === 0" class="error">
        <p class="order-info">
          订单号
          <span @click="copy(prize.orderNo)">{{ prize.orderNo }}</span>
          领取失败!
        </p>
        <p class="customer-service">
          如有疑问，请联系活动支持方易点生活电子商务有限公司进行咨询，客服热线
          <a href="tel:400-662-7299">400-662-7299</a>。
        </p>
      </div>
      <div v-if="loading" class="err-text">正在领取中，请稍后...</div>
      <div v-if="errMsg" class="err-text">{{ errMsg }}</div>
    </div>
  </div>
</template>
<script>
import store from '@/store'
import { receive } from '@/api/xibDepositStandard.js'
import useClipboard from 'vue-clipboard3'
const { toClipboard } = useClipboard()
import { Toast } from 'vant';
import moment from 'moment'

export default {
  components: {},
  data() {
    return {
      title: '厦门国际银行',
      loading: true,
      prize: {
        couponResults: undefined,  // 发券结果：1-发券成功，0-发券失败
        standardGear: undefined, // 达标档位，1：1万（含）-5万，2：5万（含）-10万，3：10万（含）-30万,4：30万（含）-50万
        orderNo: '',
        isNew: false, // 新旧活动
      },
      errMsg: '',
      details: `1.微信立减金自领取日起30日有效。不支持转发他人，不找零。过期失效。逾期不补发。 
2.使用微信支付时选择厦门国际银行借记卡支付满足立减金消费门槛自动抵扣优惠。
3.使用优惠的微信支付订单，如发生全额退款，且优惠券仍在有效期内，优惠券将自动退还给用户，如优惠券已过期，则不退还；如发生部分退款，用户支付金额将按比例原路退还，优惠券将不退还给用户。 
4.微信立减金限微信支付商家使用，个人收款码、生活缴费、理财交易、转账红包等不可使用。部分商户不支持使用，包含CoCo奶茶、优衣库、星巴克、肯德基、必胜客、同程艺龙、热风、太平鸟、孩子王、华为商城、Apple商城、零钱通、理财通。详细名单以微信官方为准。
5.立减券限用一次，不可叠加使用、不兑现、不找零、不挂失且过期作废。
6.此活动不可与其他优惠券叠加使用。
7.使用过程如有问题或疑问，请联系易点生活电子商务有限公司,客服电话：<a href="tel:400-662-7299">400-662-7299</a>。`,
      // details: `1、微信立减金在持卡人单笔消费满足立减金使用门槛并通过微信支付选择使用厦门国际银行借记卡支付时使用。若该笔订单发生全额退款，且优惠券仍在有期内，优惠券将自动退还,如优惠券已过期,则不退还;如发生部分退款该订单支付金额将按比例原路退还,优惠券将不退还。
      // 2、微信立减金限微信支付商家使用，个人收款码、生活缴费、理财交易等不可使用。部分商户不支持使用( 目前立减金不可核销的商户名单:CCo奶茶优衣库、星巴克、肯德基、必胜客、同程艺龙、热风、太平鸟、孩子王、航联保险、华为商城、Miss Sixty、Ochirly、Apple 商城、Five Plus、零钱通、理财通详细名单以微信官方为准。)
      // 3、如立减金在使用过程中出现任何问题，请联系活动支持方易点生活电子商务有限公司进行咨询，客服热线<a href="tel:400-662-7299">400-662-7299</a>。`,
      showStandardImg: false,  // 是否展示等级图片
      showStandardMap: [],  // 等级图片局部路径集合
      showStandardImgError: '', // 是否展示等级图片错误

    }
  },
  created() {
    if (this.$route.name === 'XiameBankDepositStandardWxCollecting') {
      // 监听浏览器关闭，页面刷新，清除cookie
      window.addEventListener('beforeunload', this.logout)
      window.addEventListener('unload', this.logout)
      //首页回退禁用
      history.pushState(null, null, document.URL)
      window.addEventListener('popstate', this.popstatehandle)

      let { urlToken } = this.$route.query
      if (urlToken) sessionStorage.setItem('xiameBankXibSaveMoneyToken', urlToken)
      console.log('需要微信授权的领取');
    }

    this.receive()
    this.setShowStandardMap()

  },
  methods: {
    // 设置等级图片可显示的路径集合
    setShowStandardMap() {
      let arr = []
      for (let i = 1; i < 5; i++) {
        arr.push(`${i}`)
      }
      for (let i = 1; i < 7; i++) {
        arr.push(`n${i}`)
      }
      this.showStandardMap = arr

    },
    // 领取奖品
    receive() {
      let { openId, appId } = this.$route.query
      receive({
        code: sessionStorage.getItem('ydsh-ph-h5-bankv3-wxcode'),
        openId,
        appId,
      }).then(res => {
        this.loading = false
        if (res.code === 0) {
          // 发放是判断时间大于等于2025年7月零点零点零秒，就使用新的券批次
          const { receiveTime } = res.data
          const time1 = moment(receiveTime);
          const time2 = moment('2025-07-01');
          // 比较时间
          res.data.isNew = time1.isSameOrAfter(time2) // 'time1 晚于或等于 time2' 返回 true
          this.prize = res.data

          // 判断路径是否有效
          let imgPath = `${this.prize.isNew ? 'n' : ''}${this.prize.standardGear}`
          console.log('等级图片路径', imgPath);
          if (this.showStandardMap.includes(imgPath)) {
            this.showStandardImg = true
          } else {
            this.showStandardImgError = '等级图片路径无效'
          }
        } else {
          this.errMsg = res.message
        }
      })
    },
    popstatehandle() {
      history.pushState(null, null, document.URL)
    },
    logout() {
      console.log('pagehide 关闭或者刷新 ')
      store.dispatch('user/logout')
    },
    // 复制
    async copy(text) {
      try {
        await toClipboard(text)
        Toast('订单号复制成功!')
      } catch (e) {
        console.error(e)
        Toast('订单号复制失败!')
      }
    }

  },
}
</script>
<style lang="less" scoped>
.xiame-bank-deposit-standard-wx-collecting {
  font-size: 14px;
  background: #fff;
  min-height: 100vh;

  .header {
    padding-top: 42px;
    width: 100%;
    height: 170px;
    box-sizing: border-box;
    background: url("../../../assets/imgs/xiameBankDepositStandard/bg1.jpg");
    background-size: 100% auto;
    text-align: center;

    .icon {
      width: 66px;
      margin: 0 auto;
    }
    .title {
      margin-top: 10px;
      font-weight: 500;
      font-size: 18px;
      color: #822603;
    }
  }

  .content {
    padding: 20px 0px;
    border-radius: 15px 15px 0px 0px;
    text-align: center;
    color: #595960;

    .title {
      font-size: 18px;
      color: #822603;
      line-height: 2;
    }

    .asset-img {
      width: 100%;
    }
    .tip {
      margin-top: 18px;
      font-size: 14px;
    }

    .red {
      color: #f44244;
    }

    .rule {
      margin: 25px auto 0 auto;
      width: 330px;
      padding: 10px 20px 22px 20px;
      box-sizing: border-box;
      color: #595960;
      background: #fff4ec;
      border-radius: 15px;
      text-align: left;
      line-height: 2;

      h4 {
        font-weight: 400;
        font-size: 14px;
        line-height: 2.5;
      }

      p {
        white-space: pre-line;
        text-align: justify;
        font-size: 12px;
        font-weight: 400;
        font-size: 11px;
      }
      /deep/ a {
        color: #595960;
      }
    }
    .error {
      margin: auto;
      width: 270px;

      .order-info {
        font-weight: 400;
        font-size: 14px;
        color: #595960;
        line-height: 2;
      }
      .customer-service {
        margin-top: 15px;
        font-weight: 400;
        font-size: 12px;
        color: #595960;
        line-height: 1.5;
        a {
          color: #595960;
        }
      }
    }
  }

  .err-text {
    padding: 20px;
    line-height: 1.5;
  }
}
</style>
